import { Answer } from "models/Answer";
import BaseService from "./BaseService";

export class EvaluationDisputeService extends BaseService {
    protected urlBase: string = "api/EvaluationDispute";

    public async createEvaluationDispute(
        organizationId: string,
        evaluationId: string,
        answers: Answer[],
    ) {
        const res = this.post(
            JSON.stringify({
                answers,
                organizationId,
                evaluationId,
            }),
            new URLSearchParams(),
            "DisputeEval",
            { returnJson: true },
        );

        return res;
    }
}
